import React from 'react';
import { useTranslation } from 'react-i18next';
import { IkeOrIkzeLimits } from './IkeOrIkze';

interface IkeDepositLimitProps {
  limits: IkeOrIkzeLimits;
}

const IkeDepositLimit: React.FC<IkeDepositLimitProps> = ({ limits }) => {
  const { t } = useTranslation('ike-or-ikze');

  return <>{t('ike.annual_deposit_limit', '', { limit: limits.ikeLimit, year: limits.year })}</>;
};

export default IkeDepositLimit;
